import { render, staticRenderFns } from "./UpgradeBanner.vue?vue&type=template&id=532353e0"
import script from "./UpgradeBanner.vue?vue&type=script&lang=js"
export * from "./UpgradeBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports